// Resort Description slider
document.addEventListener('DOMContentLoaded', function() {
	const slider = document.querySelector('.resort-description-slider');
	if (!slider) {
		console.warn('ResortDescription: slider not found');
		return;
	}
	
	const slides = Array.from(slider.querySelectorAll('.resort-slide'));
	const dotsContainer = slider.querySelector('.resort-slider-dots');
	
	if (slides.length === 0) {
		console.warn('ResortDescription: no slides found');
		return;
	}
	
	if (!dotsContainer) {
		console.warn('ResortDescription: dots container not found');
		return;
	}
	
	// Сортируем слайды по data-slide атрибуту, чтобы порядок был правильным
	slides.sort((a, b) => {
		const aIndex = parseInt(a.getAttribute('data-slide') || '0', 10);
		const bIndex = parseInt(b.getAttribute('data-slide') || '0', 10);
		return aIndex - bIndex;
	});
	
	// currentIndex - это индекс страницы (слайда) (0, 1, 2, ...)
	let currentIndex = 0;
	let isAutoPlaying = true;
	let autoPlayInterval;
	let dots = [];
	
	// Вычисляем количество страниц (слайдов)
	// В этом слайдере показывается по одному слайду за раз, поэтому количество страниц = количеству слайдов
	function getTotalSlides() {
		return slides.length;
	}
	
	// Создаем точки пагинации - по одной для каждой страницы
	function createDots() {
		if (!dotsContainer) {
			return;
		}
		const totalSlides = getTotalSlides();
		
		// Если страница только одна, не показываем точки
		if (totalSlides <= 1) {
			dotsContainer.style.display = 'none';
			dotsContainer.innerHTML = '';
			dots = [];
			return;
		}
		
		// Убеждаемся, что контейнер виден
		dotsContainer.style.display = 'flex';
		dotsContainer.style.visibility = 'visible';
		dotsContainer.style.opacity = '1';
		dotsContainer.style.position = 'absolute';
		dotsContainer.style.bottom = '1rem';
		dotsContainer.style.left = '50%';
		dotsContainer.style.transform = 'translateX(-50%)';
		dotsContainer.style.zIndex = '30';
		dotsContainer.innerHTML = '';
		dots = [];
		
		for (let i = 0; i < totalSlides; i++) {
			const dot = document.createElement('button');
			dot.className = 'resort-slider-dot';
			dot.setAttribute('data-slide', i);
			dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
			dot.setAttribute('type', 'button');
			if (i === currentIndex) {
				dot.classList.add('active');
				dot.style.width = '1.5rem';
				dot.style.height = '0.5rem';
				dot.style.backgroundColor = 'white';
			} else {
				dot.style.width = '0.5rem';
				dot.style.height = '0.5rem';
				dot.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
			}
			dotsContainer.appendChild(dot);
			dots.push(dot);
		}
		
		console.log('ResortDescription: created', dots.length, 'dots');
		
		// Добавляем обработчики событий для точек
		dots.forEach((dot, index) => {
			dot.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				isAutoPlaying = false;
				clearInterval(autoPlayInterval);
				currentIndex = index;
				updateSlider();
				// Перезапускаем автопрокрутку через 5 секунд
				setTimeout(function() {
					isAutoPlaying = true;
					startAutoPlay();
				}, 5000);
			});
		});
	}
	
	function updateSlider() {
		// Обновляем видимость слайдов
		slides.forEach((slide, index) => {
			if (index === currentIndex) {
				slide.classList.remove('opacity-0');
				slide.classList.add('opacity-100');
			} else {
				slide.classList.remove('opacity-100');
				slide.classList.add('opacity-0');
			}
		});
		
		// Обновляем точки пагинации
		if (dots.length > 0) {
			dots.forEach((dot, index) => {
				if (index === currentIndex) {
					dot.classList.add('active');
					dot.style.width = '1.5rem';
					dot.style.height = '0.5rem';
					dot.style.backgroundColor = 'white';
				} else {
					dot.classList.remove('active');
					dot.style.width = '0.5rem';
					dot.style.height = '0.5rem';
					dot.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
				}
			});
		}
	}
	
	function nextSlide() {
		const totalSlides = getTotalSlides();
		currentIndex = (currentIndex + 1) % totalSlides;
		updateSlider();
	}
	
	// Автопрокрутка
	function startAutoPlay() {
		const totalSlides = getTotalSlides();
		if (!isAutoPlaying || totalSlides <= 1) return;
		clearInterval(autoPlayInterval);
		autoPlayInterval = setInterval(function() {
			currentIndex = (currentIndex + 1) % totalSlides;
			updateSlider();
		}, 4000);
	}
	
	// Остановка автопрокрутки при наведении
	slider.addEventListener('mouseenter', function() {
		isAutoPlaying = false;
		clearInterval(autoPlayInterval);
	});
	
	slider.addEventListener('mouseleave', function() {
		isAutoPlaying = true;
		startAutoPlay();
	});
	
	// Инициализация
	// Находим первый слайд с opacity-100 и устанавливаем его как текущий
	let foundIndex = 0;
	slides.forEach((slide, index) => {
		if (slide.classList.contains('opacity-100')) {
			foundIndex = index;
		}
	});
	currentIndex = foundIndex;
	
	createDots();
	updateSlider();
	startAutoPlay();
	
	// Отладочная информация
	console.log('ResortDescription: initialized with', slides.length, 'slides');
	console.log('ResortDescription: currentIndex =', currentIndex);
	console.log('ResortDescription: slides order:', slides.map((s, i) => `${i}: slide-${s.getAttribute('data-slide')}`).join(', '));
});

